export default "__VITE_ASSET__DNSJ9Pxp__"